import { tokens } from "@blurb/codex-react";
import { Flex } from "@rpi/openapi-core";
import React from "react";
import { Body } from "../../../components/Typography";
import { AccountSettingsCard } from "./AccountSettingsCard";
import { EMPTY_FIELD_PLACEHOLDER, WEBSITE_PLACEHOLDER } from "./accountSettingsCopy";
import { FieldFrame } from "./FieldFrame";
import { FieldRow } from "./FieldRow";
import { LabeledField } from "./LabeledField";

interface OrganizationInformationCardProps {
  organizationName?: string | null;
  canEdit: boolean;
  onEdit: () => void;
}

export const OrganizationInformationCard: React.FC<OrganizationInformationCardProps> = ({
  organizationName,
  canEdit,
  onEdit,
}) => {
  return (
    <AccountSettingsCard
      title="Organization Information"
      onEdit={canEdit ? onEdit : undefined}
      data-testid="organization-information-card"
    >
      <FieldFrame>
        <Flex.Column gap={2}>
          <Body size="lg" weight="bold" data-testid="organization-information-name">
            {organizationName || EMPTY_FIELD_PLACEHOLDER}
          </Body>
          <Flex sx={{ color: tokens.color.semantic.text.subtle }}>
            <Body>{WEBSITE_PLACEHOLDER}</Body>
          </Flex>
        </Flex.Column>

        <FieldRow>
          <LabeledField label="Size" value={EMPTY_FIELD_PLACEHOLDER} />
          <LabeledField label="Country" value={EMPTY_FIELD_PLACEHOLDER} />
        </FieldRow>
      </FieldFrame>
    </AccountSettingsCard>
  );
};
